import { render, staticRenderFns } from "./SortingModal.vue?vue&type=template&id=c9544ac0&scoped=true&lang=pug"
import script from "./SortingModal.vue?vue&type=script&lang=js"
export * from "./SortingModal.vue?vue&type=script&lang=js"
import style0 from "./SortingModal.vue?vue&type=style&index=0&id=c9544ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9544ac0",
  null
  
)

export default component.exports